const CONSTRUCTION_PATH =
  "M1.85159e-06 9.27552L3.89066 9.27552L3.89066 13.2296L14.7196 9.97706C15.0439 9.40308 15.5194 8.93007 16.1462 8.55804C16.773 8.18601 17.4431 8 18.1564 8C19.2371 8 20.1558 8.37203 20.9123 9.11608C21.6688 9.86014 22.047 10.7636 22.047 11.8266C22.047 12.6557 21.8039 13.3944 21.3175 14.0428C20.8312 14.6912 20.2098 15.1429 19.4533 15.398L19.4533 19.4797L20.7502 19.4797C21.1176 19.4797 21.4256 19.6019 21.6742 19.8464C21.9228 20.0909 22.047 20.3938 22.047 20.7552C22.047 20.9466 22.0038 21.1326 21.9174 21.3133C21.8309 21.494 21.7012 21.6481 21.5283 21.7756L23.6033 23.944C23.7978 24.1354 23.9221 24.3639 23.9762 24.6296C24.0302 24.8954 23.9924 25.1558 23.8627 25.4109L21.5283 30.3854C21.3986 30.6405 21.2095 30.8159 20.9609 30.9116C20.7123 31.0072 20.4692 31.0019 20.2314 30.8956C19.972 30.7681 19.8045 30.5821 19.7289 30.3376C19.6532 30.0931 19.6694 29.854 19.7775 29.6201L21.9174 25.0282L19.0642 22.0308L17.2486 22.0308L14.4603 25.0282L16.6001 29.6201C16.7082 29.854 16.719 30.0984 16.6325 30.3535C16.5461 30.6086 16.384 30.7893 16.1462 30.8956C15.8868 31.0232 15.6383 31.0338 15.4005 30.9275C15.1627 30.8212 14.979 30.6405 14.8493 30.3854L12.4501 25.4109C12.3204 25.1558 12.2826 24.8954 12.3366 24.6296C12.3907 24.3639 12.5149 24.1354 12.7095 23.944L14.7845 21.7756C14.6548 21.6481 14.5359 21.494 14.4278 21.3133C14.3198 21.1326 14.2657 20.9466 14.2657 20.7552C14.2657 20.3938 14.39 20.0909 14.6386 19.8464C14.8872 19.6019 15.1952 19.4797 15.5626 19.4797L16.8595 19.4797L16.8595 15.398C16.6866 15.3343 16.5245 15.2652 16.3732 15.1908C16.2219 15.1164 16.0598 15.0154 15.8868 14.8878L3.89065 21.2654L3.89065 25.8573L1.12678e-06 25.8573L1.85159e-06 9.27552ZM16.8595 11.8266C16.8595 12.188 16.9838 12.4909 17.2324 12.7354C17.4809 12.9799 17.7889 13.1021 18.1564 13.1021C18.5238 13.1021 18.8319 12.9799 19.0804 12.7354C19.329 12.4909 19.4533 12.188 19.4533 11.8266C19.4533 11.4652 19.329 11.1622 19.0804 10.9178C18.8319 10.6733 18.5238 10.551 18.1564 10.551C17.7889 10.551 17.4809 10.6733 17.2324 10.9178C16.9838 11.1622 16.8595 11.4652 16.8595 11.8266ZM3.89066 15.8445L3.89066 18.3317L14.2657 12.847L14.2657 12.7194L3.89066 15.8445Z";

/**
 * Construction glyph — crane, no tile. A filled shape, so the colour comes
 * from a `fill-*` class in `className`.
 */
export default function ConstructionCiqIcon({
  size = 12,
  className = "fill-black",
  opacity = "0.6"
}: {
  size?: number;
  className?: string;
  opacity?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 7.5 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d={CONSTRUCTION_PATH} fillOpacity={opacity} />
    </svg>
  );
}

/**
 * Construction phase badge — the same crane on its fixed-colour tile.
 * Design: 36×36 container (#2E3199) + glyph (#D746FF). Used by CiqIconBox.
 */
export function ConstructionTileCiqIcon({
  size = 36,
  className = ""
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V32C36 34.2091 34.2091 36 32 36H4C1.79086 36 0 34.2091 0 32V4Z"
        fill="#2E3199"
      />
      <path d={CONSTRUCTION_PATH} fill="#D746FF" />
    </svg>
  );
}
